<template>
  <div class="content-body tenant-settings">
    <div class="">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
        <el-form-item label="子公司" prop="subcompanyIdList">
          <el-select multiple  v-model="dataForm.subcompanyIdList" @change="getSupCompanyList" class="input-width">
            <el-option
                v-for="item in supCompanyList"
                :key="item.id"
                :label="item.orgName"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="协议编码:" label-width="86px">
          <el-input size="small" v-model="dataForm.priceAgreementCode" placeholder="协议编码" clearable
                    @blur="getDataList"></el-input>
        </el-form-item>
        <el-form-item label="负责人:">
          <el-input size="small" v-model="dataForm.partyaRepresentive" placeholder="负责人" clearable
                    @blur="getDataList"></el-input>
        </el-form-item>
        <el-form-item label="协议状态:">
          <el-select size="small" v-model="dataForm.agreementStatus" placeholder="请选择状态" clearable
                     @change="getDataList">
            <el-option v-for="item in AGREEMENT_STATUS" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <!-- <el-input size="small" v-model="dataForm.agreementStatus" placeholder="协议状态" clearable @blur="getDataList"></el-input> -->
        </el-form-item>
        <el-form-item label="协议类型:">
          <el-select size="small" v-model="dataForm.agreementTypeList" placeholder="请选择类型" clearable
                     @change="getDataList" multiple>
            <el-option v-for="item in AGREEMENT_TYPE" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <!-- <el-input size="small" v-model="dataForm.agreementType" placeholder="协议类型" clearable @blur="getDataList"></el-input> -->
        </el-form-item>
        <el-form-item label="供应商编码:">
          <el-input size="small" v-model="dataForm.partybCode" placeholder="供应商编码" clearable
                    @blur="getDataList"></el-input>
        </el-form-item>
        <el-form-item label="甲方:" label-width="57px">
          <el-input size="small" v-model="dataForm.purchasePartya" placeholder="甲方" clearable
                    @blur="getDataList"></el-input>
        </el-form-item>
        <el-form-item label="乙方:" label-width="71px">
          <el-input size="small" v-model="dataForm.supplierPartyb" placeholder="乙方" clearable
                    @blur="getDataList"></el-input>
        </el-form-item>
        <el-form-item label="同步状态:">
          <el-cascader v-model="syncStatuses" :options="SYNC_STATUS_PRICE"
                       :props="{ multiple: true, checkStrictly: true }" collapse-tags clearable></el-cascader>
        </el-form-item>
        <el-form-item label="询价单编码:" label-width="86px">
          <el-input size="small" v-model="dataForm.rfqCode" placeholder="询价单编码" clearable
                    @blur="getDataList"></el-input>
        </el-form-item>
        <el-form-item class="fr">
          <el-form-item>
            <el-button size="small" @click="queryHandle()" icon="el-icon-search">
              查询
            </el-button>
          </el-form-item>
          <el-button size="small" type="primary" @click="xuqian()" icon="el-icon-plus">
            续签价格协议
          </el-button>
          <el-button size="small" plain v-if="isAuth('sourcing:priceAgreement:newbutton')" type="primary"
                     @click="addOrUpdateHandle()" icon="el-icon-plus">
            新建价格协议
          </el-button>
          <!-- <el-button size="small" type="success" icon="el-icon-plus">
              通过
          </el-button>
          <el-button size="small" type="danger" icon="el-icon-plus">
              驳回
          </el-button> -->
          <!--<el-button size="small" plain type="warning" icon="el-icon-plus" @click="pushSaps()">
              批量推送SAP
          </el-button>-->
          <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
              导入订单
          </el-button> -->
        </el-form-item>
      </el-form>
      <div v-loading="dataListLoading">
        <el-table :header-cell-style="{background:'#f5f5f5'}" @selection-change="selectionChangeHandle" :data="dataList"
                  row-key="id" size="small" bPriceAgreement style="width: 100%;" :default-expand-all="false" border
                  :height="tableHeight">
          <el-table-column type="selection" :selectable='checkboxSelect' width="55">
          </el-table-column>
          <el-table-column type="index" width="50" label="序号">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column prop="syncStatus" header-align="center" align="center" label="同步状态" width="100">
            <template slot-scope="scope">
              <span :class="getSyncStatusClass(scope.row.syncStatus)">{{ getSyncStatus(scope.row.syncStatus) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="priceAgreementCode" header-align="center" align="left" label="协议编码" width="160">
          </el-table-column>
          <el-table-column prop="rfqCode" header-align="center" align="left" label="询价单编码" width="160">
          </el-table-column>
          <!-- 定厂 样件 试制 量产 售后备件  -->
          <el-table-column prop="agreementType" header-align="center" align="center" label="协议类型" width="130">
            <template slot-scope="scope">
              {{ getAgreementTypeByValue(scope.row.agreementType) }}
            </template>
          </el-table-column>
          <el-table-column prop="agreementStatus" header-align="center" align="center" label="协议状态" width="100">
            <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.agreementStatus)">
                            {{ agreementStatusFormat(scope.row.agreementStatus) }}
                        </span>
            </template>
          </el-table-column>
          <el-table-column prop="taxRate" header-align="center" align="center" label="增值税税率" width="90">
            <template slot-scope="scope">
              <span>{{ getTaxCodeName(scope.row.taxRate) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="payPeriod" header-align="center" align="center" label="账期" width="200">
            <template slot-scope="scope">
              {{ getPayPeriodValue(scope.row.payPeriod) }}
            </template>
          </el-table-column>
          <el-table-column prop="payWay" header-align="center" align="center" label="付款方式" width="150">
            <template slot-scope="scope">
              {{ getPayWayValue(scope.row.payWay) }}
            </template>
          </el-table-column>
          <el-table-column prop="contractCode" header-align="center" align="left" label="合同编码" width="200">
          </el-table-column>
          <el-table-column prop="purchasePartyaName" header-align="center" align="left" label="甲方" width="280">
          </el-table-column>
          <el-table-column prop="partyaSignDate" header-align="center" align="right" label="甲方签订日"
                           :formatter="dateFormat" width="170">
          </el-table-column>
          <el-table-column prop="supplierPartyb" header-align="center" align="left" label="乙方" width="280">
          </el-table-column>
          <el-table-column prop="partybSignDate" header-align="center" align="right" label="乙方签订日"
                           :formatter="dateFormat" width="170">
          </el-table-column>
          <el-table-column prop="partybCode" header-align="center" align="center" label="供应商编码" width="120">
          </el-table-column>
          <el-table-column prop="validityOfContract" header-align="center" align="left" label="协议有效期" width="200">
            <template slot-scope="scope">
                        <span v-if="scope.row.contractStartDate && scope.row.contractEndDate">
                            {{ scope.row.contractStartDate }} - {{ scope.row.contractEndDate }}
                        </span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" header-align="center" align="center" label="创建时间" width="170">
          </el-table-column>
          <el-table-column prop="unQuoteReason" header-align="center" align="left" label="驳回原因" width="200">
          </el-table-column>
          <el-table-column prop="pic" header-align="center" align="center" width="120" label="当前流程图示">
            <template slot-scope="scope">
              <el-link :disabled="scope.row.agreementStatus === '流程结束' || scope.row.agreementStatus === '已同步'" type="primary" style="font-size: 12px;" @click="viewDiagram(scope.row.workflowId, scope.row)"><i class="el-icon-view" style="margin-right: 5px;"></i>查看</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="createBy" header-align="center" align="center" label="审批历史" width="120">
            <template slot-scope="scope">
              <el-button @click="doHistory(scope.row)">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                查看
              </el-button>
              <el-button :disabled="scope.row.syncStatus == 1 ? true : false" type="text" size="small"
                         @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                修改
              </el-button>
              <el-button
                  :disabled="scope.row.syncStatus == 1 ? true : false || ((strStart(scope.row.priceAgreementCode) == 0||strStart1(scope.row.priceAgreementCode) == 0) && scope.row.agreementStatus != '流程结束')|| scope.row.syncing"
                  v-if="isAuth('sourcing:priceAgreement:push')" type="text" size="small" @click="pushSap(scope.row)"
                  icon="el-icon-edit">
                同步
              </el-button>
              <el-button  :disabled="!((scope.row.agreementStatus === null || scope.row.agreementStatus === '') && (scope.row.agreementType == null))"  type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="button-danger">
                删除
              </el-button>
              <!-- <el-button type="text" size="small" @click="exportData(scope.row)" icon="el-icon-edit">
                  导出
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>

      <el-dialog title="续签价格协议" width="40%" :visible.sync="xuqianVisible" :rules="dataRule" @close='closeDialog'>
        <el-form :model="dataForm1" :rules="dataRule" ref="dataForm1" @keyup.enter.native="dataFormSubmit()"
                 label-width="100px" class="tenant-dialog-form">
          <el-form-item label="子公司：" prop="subcompanyId">
            <el-select  v-model="dataForm1.subcompanyId" @change="handleSubcompanyChange" style="width: 100%">
              <el-option
                  v-for="item in supCompanyList"
                  :key="item.id"
                  :label="item.orgName"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商码" prop="supplierCode">
            <span>{{ dataForm1.supplierCode + '_' + dataForm1.supplierName }}</span>&nbsp;&nbsp;
            <el-button size="small" plain type="primary" @click="chooseSupplier()">
              选择
            </el-button>
          </el-form-item>
          <el-form-item label="协议有效期" prop="validityDate">
            <el-date-picker v-model="dataForm1.validityDate" type="daterange" value-format="yyyy-MM-dd"
                            range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期"></el-date-picker>
          </el-form-item>

          <el-form-item label="工厂" prop="factoryCode">
            <el-select v-model="dataForm1.factoryCode" placeholder="请选择" @visible-change="onDropdownVisibleChange">
              <el-option v-for="item in factoryList" :key="item.orgCode"
                         :label="`${item.orgCode} - ${item.orgName}`" :value="item.orgCode"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="导入模板" prop="file">
            <el-upload
                ref="upload"
                :auto-upload="false"
                drag
                action
                :http-request="upload"
                :limit="1"
                accept=".xls"
                :on-change="fileChange"
                :on-remove="fileRemove"
                multiple>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div cla3ss="el-upload__tip" slot="tip">只能上传xls文件，且不超过500kb</div>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="exportTemplate()">
                    <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;导出模板
                </el-button>
                <el-button size="small" @click="xuqianVisible = false">取消
                </el-button>
                <el-button size="small" type="primary" @click="dataFormSubmit()">确定
                </el-button>
            </span>
      </el-dialog>
      <el-drawer title="审批履历" :visible.sync="drawer" :with-header="true">
        <div v-for="str in historyList" :key="str">
          <el-descriptions :title="str.executeTime">
            <el-descriptions-item label="审批类型">{{ str.taskName }}</el-descriptions-item>
            <el-descriptions-item label="审批结果">{{ str.executeName }}</el-descriptions-item>
          </el-descriptions>
          <el-divider></el-divider>
        </div>
      </el-drawer>
      <supplier-select-dialog ref="supplierSelectDialog" @refreshPartList="getPartList"></supplier-select-dialog>
      <error-message v-if="errorMessageVisible" ref="errorMessage"></error-message>

      <el-dialog :visible.sync="showViewer" width="80%" title="流程图">
        <el-image :src="diagramUrl" style="margin-bottom: 120px;">
        </el-image>
      </el-dialog>

      <el-dialog :visible.sync="showWorkflowDialog" width="70%" title="审批进度" :close-on-click-modal="false">
        <div class="workflow-container">
          <div class="workflow-steps">
            <!-- 节点 1: 提交价格协议 -->
            <div class="step" :class="getStepClass(1)">
              <div class="step-circle">1</div>
              <div class="step-label">提交价格协议</div>
              <div class="step-status">{{ getStepStatusText(1) }}</div>
            </div>

            <!-- 连线 1→2 -->
            <div class="step-line" :class="getLineClass(1, 2)"></div>

            <!-- 节点 2: 供应商管理员审批 -->
            <div class="step" :class="getStepClass(2)">
              <div class="step-circle">2</div>
              <div class="step-label">供应商管理员审批</div>
              <div class="step-status">{{ getStepStatusText(2) }}</div>
            </div>

            <!-- 连线 2→3 -->
            <div class="step-line" :class="getLineClass(2, 3)"></div>

            <!-- 节点 3: 流程结束 -->
            <div class="step" :class="getStepClass(3)">
              <div class="step-circle">3</div>
              <div class="step-label">流程结束</div>
              <div class="step-status">{{ getStepStatusText(3) }}</div>
            </div>
          </div>

          <!-- 当前状态说明 -->
          <div class="current-status">
            <h4>当前状态：{{ getCurrentStatusText() }}</h4>
            <p>{{ getCurrentStatusDesc() }}</p>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getTaxCodeList,
  getFactoryList
} from '@/controller/systemData'
import {
  exportPartTemplate,
  getPriceAgreementList,
  removePriceAgreement,
  exportPriceArgument,
  pushSapBackPrice,
  checkDate,
  importPartTemplate,
  getWerkList
} from '@/controller/priceAgreement'
import {
  listAllStatus,
  getProcessDiagramCurrent,
  listCommentHistory
} from '@/controller/workflow'
import {
  AGREEMENT_STATUS,
  getLabelByValue,
  AGREEMENT_TYPE,
  getAGREEMENT_TYPE_VALUE,
  getPAY_WAY_VALUE,
  getPAY_PERIOD_VALUE,
  SYNC_STATUS_PRICE,
  getSYNC_STATUS_VALUE,
} from '@/utils/const'
import AddOrUpdate from './price-aggreement-add-or-update'
import supplierSelectDialog from "./supplier-select-dialog";
import moment from 'moment'
import ErrorMessage from "../../supplier/supplierEvaManage/error-message.vue";
import {supCompanyList} from "../../../../controller/sys";
// require('@/mock/mockPriceAgreement');
export default {
  data() {
    return {
      documentClientHeight: document.documentElement['clientHeight'] - 310,
      dataForm: {
        agreementTypeList: [],
        priceAgreementCode: '',
        partyaRepresentive: '',
        agreementStatus: '',
        agreementType: '',
        partybCode: '',
        purchasePartya: '',
        supplierPartyb: '',
        syncStatuses: [],
        syncStatus: '',
        rfqCode: '',
        subcompanyIdList:[],
      },
      supCompanyList: [],
      factoryList: [],
      dataForm1: {
        id: 0,
        supplierCode: '',
        supplierName: '',
        purOrg: '',
        validityDate: '',
        name: '',
        fileList: [],
        file: null,
        factoryCode: '',
        subcompanyId:''
      },
      errorMessageVisible: false,
      dataRule: {
        purOrg: [{
          required: true,
          message: '采购组织不能为空',
          trigger: 'blur'
        }],
        evaYear: [{
          required: true,
          message: '评价年度不能为空',
          trigger: 'blur'
        }],
        evaType: [{
          required: true,
          message: '年度分类不能为空',
          trigger: 'blur'
        }],
        file: [{
          required: true,
          message: '导入模板不能为空',
          trigger: 'change'
        }],
      },
      supplierSelectDialogVisible: false,
      dataList: [],
      tenantList: [],
      taxCodeList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      // 协议类型
      AGREEMENT_STATUS: AGREEMENT_STATUS,
      // 同步状态
      SYNC_STATUS_PRICE: SYNC_STATUS_PRICE,
      getLabelByValue: getLabelByValue,
      // 协议状态
      AGREEMENT_TYPE: AGREEMENT_TYPE,
      getAgreementTypeByValue: getAGREEMENT_TYPE_VALUE,
      getPayWayValue: getPAY_WAY_VALUE,
      getPayPeriodValue: getPAY_PERIOD_VALUE,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      xuqianVisible: false,
      // 审批历史
      drawer: false,
      // 审批列表
      historyList: [],
      showViewer: false,
      diagramUrl: '',
      syncStatuses: [],
      // 新增：工作流相关
      showWorkflowDialog: false,  // 控制工作流对话框显示
      currentWorkflowStatus: '', // 当前协议状态
      workflowSteps: [
        { step: 1, name: '提交价格协议', status: '' },
        { step: 2, name: '供应商管理员审批', status: '' },
        { step: 3, name: '流程结束', status: '' }
      ],
      statusPriority: {
        '提交价格协议': 1,
        '供应商管理员审批': 2,
        '流程结束': 3,
        '已同步': 4
      }
    }
  },
  computed: {
    tableHeight: {
      get() {
        return this.$store.state.common.documentClientHeight - 330
      }
    }
  },
  components: {
    ErrorMessage,
    AddOrUpdate,
    supplierSelectDialog
  },
  activated() {
    this.getDataList()
    this.getTaxCodeList()
  },
  methods: {
    // 审批历史
    doHistory(row) {
      this.historyList = []
      listCommentHistory({
        'workflowId': row.workflowId
      }).then(data => {
        if (data && data.code === '00') {
          this.historyList = data.body
        } else {
          this.$message.error(data.msg)
        }
      })
      this.drawer = true

    },
    viewDiagram(id) {
      const currentRow = this.dataList.find(item => item.workflowId === id);
      if (currentRow) {
        this.currentWorkflowStatus = currentRow.agreementStatus;
        this.showWorkflowDialog = true;
      } else {
        // 如果找不到对应行,调用原来的接口(兼容旧功能)
        getProcessDiagramCurrent({
          id: id
        }).then(data => {
          this.diagramUrl = data.body
          this.showViewer = true
        })
      }
    },
    getStepClass(step) {
      const status = this.getStepStatus(step);
      return {
        'step-completed': status === 'completed',
        'step-current': status === 'current',
        'step-pending': status === 'pending'
      };
    },
    // 获取连线样式类
    getLineClass(fromStep, toStep) {
      const fromStatus = this.getStepStatus(fromStep);
      const toStatus = this.getStepStatus(toStep);

      // 如果前一个节点已完成，连线显示为完成状态
      if (fromStatus === 'completed' && (toStatus === 'current' || toStatus === 'completed')) {
        return 'line-completed';
      }
      // 如果前一个节点是进行中，且后一个节点是当前节点
      else if (fromStatus === 'current' && toStatus === 'current') {
        return 'line-active';
      }
      return 'line-pending';
    },

    // 获取步骤状态
    getStepStatus(step) {
      const status = this.currentWorkflowStatus;
      const priority = this.statusPriority[status] || 0;

      // 定义各状态的预期流程
      const statusSequence = [
        { step: 1, name: '提交价格协议', requiredStatus: '提交价格协议' },
        { step: 2, name: '供应商管理员审批', requiredStatus: '供应商管理员审批' },
        { step: 3, name: '流程结束', requiredStatus: '流程结束' }
      ];

      // 找到当前步骤对应的配置
      const currentStepConfig = statusSequence.find(s => s.step === step);
      if (!currentStepConfig) return 'pending';

      // 如果当前状态等于该步骤的状态，则为进行中
      if (status  === currentStepConfig.requiredStatus) {
        return 'current';
      }

      // 如果当前状态优先级高于该步骤的状态，则为已完成
      if (priority > this.statusPriority[currentStepConfig.requiredStatus]) {
        return 'completed';
      }

      // 否则为待处理
      return 'pending';
    },

    // 获取步骤状态文本
    getStepStatusText(step) {
      const status = this.getStepStatus(step);
      switch (status) {
        case 'completed':
          return '✓ 已完成';
        case 'current':
          return '▶ 进行中';
        case 'pending':
          return '○ 待处理';
        default:
          return '';
      }
    },

    // 获取当前状态文本
    getCurrentStatusText() {
      const statusMap = {
        '提交价格协议': '草稿状态',
        '供应商管理员审批': '等待供应商管理员审批',
        '流程结束': '流程已完成',
        '已同步': '已同步至SAP'
      };
      return statusMap[this.currentWorkflowStatus] || this.currentWorkflowStatus;
    },

    // 获取当前状态描述
    getCurrentStatusDesc() {
      const descMap = {
        '提交价格协议': '价格协议已创建，等待提交',
        '供应商管理员审批': '供应商管理员正在审核价格协议内容',
        '流程结束': '所有审批环节已完成，价格协议生效',
        '已同步': '价格协议已同步至SAP系统'
      };
      return descMap[this.currentWorkflowStatus] || '暂无状态描述';
    },
    dateFormat: function (row, column) {
      var date = row[column.property]
      if (date == undefined) {
        return ''
      }
      return moment(date).format("YYYY-MM-DD")
    },
    // 协议状态
    agreementStatusFormat: function (value) {
      // var value = row[column.property]
      if (!value) {
        return ''
      }
      return getLabelByValue(AGREEMENT_STATUS, value)
    },
    getPartList(val) {
      debugger
      console.log("val====" + val);
      //this.dataForm.partList = val
      this.dataForm1.supplierCode = val.venderCode
      this.dataForm1.supplierName = val.venderName
    },
    // 付款方式
    //    payWayFormat: function (row, column) {
    //         var value = row[column.property]
    //         if (!value) {
    //             return ''
    //         }
    //         return getPAY_WAY_VALUE(value)
    //     },
    //获取同步状态
    getSyncStatus(val) {
      var type = this.SYNC_STATUS_PRICE.find(type => type.value === val)
      return type ? type.label : ''
    },
    // 查询按钮
    queryHandle() {
      this.pageIndex = 1
      this.getDataList()
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      this.getSupCompanyList();
      this.dataForm.syncStatuses = []
      this.syncStatuses.forEach(status => {
        this.dataForm.syncStatuses.push(status[0])
      })
      getPriceAgreementList({
        'pageSize': this.pageSize,
        'pageNo': this.pageIndex,
        ...this.dataForm
      }).then(data => {
        console.log(data, 'data')
        if (data && data.code === '00') {
          //this.dataList = data.body.records
          this.dataList = data.body.records.map(record => ({
            ...record,
            syncing: false // 设置 syncing 为 false
          }));
          this.totalPage = data.body.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    // 查看
    viewHandle(row) {
      console.log(row)
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(row, row ? row.id : null, 'view')
      })
    },
    // 新增 / 修改
    xuqian() {
      this.xuqianVisible = true
      this.getSupCompanyListxuqian(); // 打开弹窗时获取子公司列表

    },
    // 子公司选择变化处理
    handleSubcompanyChange() {
      const subcompanyId = this.dataForm1.subcompanyId;
      if (subcompanyId) {
        // 通过子公司ID找到对应的子公司对象
        console.log("所选子公司ID",subcompanyId);
        console.log("子公司列表",this.supCompanyList);
        const selectedSubcompany = this.supCompanyList.find(item => item.id === subcompanyId);
        console.log("所选子公司code",selectedSubcompany.orgCode);
        if (selectedSubcompany && selectedSubcompany.orgCode) {
          // 将子公司Code传递给工厂查询方法
          this.getFactoryList(selectedSubcompany.orgCode);
        } else {
          this.factoryList = [];
          this.dataForm1.factoryCode = '';
          this.$message.warning('未找到子公司Code，请联系管理员');
        }
      } else {
        this.factoryList = [];
        this.dataForm1.factoryCode = '';
      }
    },
    // 获取子公司列表
    getSupCompanyListxuqian() {
      supCompanyList().then(res => {
        if (res && res.code === '00') {
          this.supCompanyList = res.body;

          // 自动选择逻辑：如果只有一个子公司，自动选中
          if (this.supCompanyList.length === 1) {
            this.dataForm1.subcompanyId = this.supCompanyList[0].id;
            this.handleSubcompanyChange();
          } else {
            this.dataForm1.subcompanyId = null;
            this.factoryList = [];
            this.dataForm1.factoryCode = '';
          }
        }
      });
    },
    closeDialog() {
      this.getDataList()
      // 重置子公司选择
      this.dataForm1.subcompanyId = null;
    },
    chooseSupplier() {
      this.$refs.supplierSelectDialog.open();
      this.$refs.supplierSelectDialog.onClosed = (payload) => {
        if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
          this.dataForm1.supplierCode = payload.data.venderCode
          this.dataForm1.supplierName = payload.data.venderName
        }
      };
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm1'].validate((valid) => {
        if (valid) {
          this.$refs.upload.submit();
        }
      })
    },
    upload(obj) {
      let formData = new FormData()
      formData.set('file', obj.file)
      formData.set('supplierCode', this.dataForm1.supplierCode)
      formData.set('startDate', this.dataForm1.validityDate && this.dataForm1.validityDate.length === 2 ? this.dataForm1.validityDate[0] : null)
      formData.set('endDate', this.dataForm1.validityDate && this.dataForm1.validityDate.length === 2 ? this.dataForm1.validityDate[1] : null)
      formData.set('factoryCode', this.dataForm1.factoryCode)
      formData.set('subcompanyId',this.dataForm1.subcompanyId)
      debugger
      //输入的起始日期是否大于该供应商的价格协议的截止日期，如果存在空档期，给用户做确认提示：“续签供应商已有价格协议的最后截止日期为 2024-01-01（这里是校验接口返回的截止日期），小于设置的续签起始日期2025-01-01（这里是startDate）。继续操作生成的价格协议将存在空档期，是否确认继续操作？
      checkDate({
        'supplierCode': this.dataForm1.supplierCode,
        'startDate': formData.get('startDate'),
        'endDate': formData.get('endDate'),
        'factoryCode': this.dataForm1.factoryCode,
      }).then(data => {
        if (data && data.code === '00') {
          const lastEndDate = data.body; // 假设接口返回的最后截止日期字段为 lastEndDate
          const startDate = formData.get('startDate');

          if (lastEndDate && startDate) {
            const lastEndDateObj = new Date(lastEndDate);
            const startDateObj = new Date(startDate);

            if (startDateObj > lastEndDateObj) {
              // 存在空档期，给出用户确认提示
              this.$confirm(`续签供应商已有价格协议的最后截止日期为 ${lastEndDate}，小于设置的续签起始日期 ${startDate}。继续操作生成的价格协议将存在空档期，是否确认继续操作？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                // 用户点击确定后的操作
                this.continueOperation(formData);
              }).catch(() => {
                this.xuqianVisible = true
                // 用户点击取消后的操作
                this.$message({
                  type: 'info',
                  message: '已取消操作'
                });
              });
            } else {
              // 不存在空档期，继续操作
              this.continueOperation(formData);
            }
          } else {
            // 如果 lastEndDate 或 startDate 为空，继续操作
            this.continueOperation(formData);
          }
        } else {
          // 处理接口返回的其他情况
          this.$message({
            type: 'error',
            message: '日期校验失败，请重试'
          });
        }
      }).catch(error => {
        console.error('日期校验接口调用失败', error);
        this.$message({
          type: 'error',
          message: '日期校验接口调用失败，请重试'
        });
      });
    },
    continueOperation(formData) {
      console.log('fromdata是',formData);
      importPartTemplate(formData).then((data) => {
        if (data.code === '00') {
          this.$refs.upload.clearFiles()
          this.$message.success({
            message: '导入成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.xuqianVisible = false
              this.dataForm1.supplierName=''
              this.dataForm1.supplierCode=''
              this.dataForm1.factoryCode=''
              this.dataForm1.validityDate=''
              this.getDataList()
            }
          })
        } else {
          // this.xuqianVisible = false
          // this.$message.error(data.msg);
          this.errorMessageVisible = true
          this.$nextTick(() => {
            this.$refs.errorMessage.init(data.msg)
          })
        }
      }).catch((e) => {
        this.xuqianVisible = false
      })
    },
    // 导出模板
    exportTemplate() {
      exportPartTemplate().then((data) => {
        this.readAsBinaryString(data.body)
      })
    },
    fileChange(uploadFile, fileList) {
      this.dataForm1.file = uploadFile
      if (fileList.length !== 0) {
        this.$refs.dataForm1.validateField('file')
      }
    },
    fileRemove(uploadFile, fileList) {
      if (fileList.length === 0) {
        this.dataForm1.file = null
        this.$refs.dataForm1.validateField('file')
      }
    },
    onDropdownVisibleChange(visible) {
      // 下拉框展开时触发该方法
      if (visible && this.dataForm1.subcompanyId) {
        const selectedSubcompany = this.supCompanyList.find(item => item.id === this.dataForm1.subcompanyId);
        if (selectedSubcompany && selectedSubcompany.code) {
          this.getFactoryList(selectedSubcompany.code);
        }
      }
    },
    getFactoryList(subcompanyCode) {
      getWerkList({},subcompanyCode).then(data => {
        if (data && data.code === '00') {
          this.factoryList = data.body;
          if(this.factoryList.length===0){
            this.dataForm1.factoryCode=''
          }
        }
      })
    },
    // 新增 / 修改
    addOrUpdateHandle(row) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(row, row ? row.id : null, 'edit')
      })
    },
    // 删除
    deleteHandle(id) {
      console.log(id)
      this.$confirm(`确定进行删除操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removePriceAgreement({}, id).then(data => {
          if (data && data.code === '00') {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    //获取税码信息
    getTaxCodeList() {
      getTaxCodeList({
        taxCode: "",
        taxRate: ""
      }).then(data => {
        if (data && data.code === '00') {
          this.taxCodeList = data.body;
        }
      })
    },
    getTaxCodeName(code) {
      const taxCode = this.taxCodeList.find(taxCode => taxCode.taxCode === code)
      return taxCode ? taxCode.taxRate : ''
    },
    exportData(rec) {
      exportPriceArgument(rec).then(data => {
        if (data && data.code === '00') {

          console.log(data)
          this.readAsBinaryString(data.body)
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              // this.getDataList()
            }
          })
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    readAsBinaryString(data) {
      // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
      //const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
      const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
      const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
      let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
      dom.style.display = 'none';
      dom.href = url;
      dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
      document.body.appendChild(dom);
      dom.click();
    },
    str2Blob(str, mime) {
      var arr = str.split(',')
      var bstr = atob(arr[0]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime
      });
    },
    //禁用checkbox
    checkboxSelect(row, rowIndex) {
      if (row.syncStatus == 1) {
        return false // 禁用
      } else {
        return true // 不禁用
      }
    },
    //推送sap
    pushSaps() {
      if (this.dataListSelections.length == 0) {
        this.$message.warning("请选择数据")
        return
      }
      this.$confirm('当前共选中' + this.dataListSelections.length + '条数据进行批量推送。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const ids = [];
        for (let index = 0; index < this.dataListSelections.length; index++) {
          ids.push(this.dataListSelections[index].id);
        }
        pushSapBackPrice(ids).then(data => {
          if (data.code === '00') {
            this.$message.success({
              message: '推送完成',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
                this.$emit("refreshDataList")
              }
            })
          } else {
            this.$message.error(data.msg);
          }
        })
      })
    },
    pushSap(row) {
      row.syncing = true;
      const ids = [];
      ids.push(row.id);
      pushSapBackPrice(ids).then(data => {
        if (data.code === '00') {
          this.$message.success({
            message: '推送完成',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.getDataList()
              this.$emit("refreshDataList")
            }
          });
          setTimeout(() => {
            row.syncing = false;
          }, 5000); // 5000毫秒即5秒
        } else {
          this.$message.error(data.msg);
          row.syncing = false;
        }
      }).catch(() => {
        this.$message.error('请求失败');
        row.syncing = false; // 如果接口调用失败，立即设置 syncing 为 false
      });
    },
    getStatusClass(status) {
      let className = ''
      switch (status) {
        case '提交价格协议':
          className = "text-primary"
          break;
        default:
          className = 'text-success'
          break;
      }
      return className
    },
    getSyncStatusClass(status) {
      let className = ''
      switch (status) {
        case 0:
          className = "text-primary"
          break;
        case 2:
          className = "text-danger"
          break;
        default:
          className = 'text-success'
          break;
      }
      return className
    },
    strStart(str) {
      return str.indexOf('PA')
    },
    //获取子公司列表
    getSupCompanyList(){
      supCompanyList().then(res=>{
        if(res && res.code == '00'){
          this.supCompanyList = res.body;
        }
      })
    },
    strStart1(str) {
      return str.indexOf('XQ')
    },
    /*isDisabled(val) {
        if(val === this.userRealName) {
            return false
        } else {
            return true
        }
    },*/

  }
}
</script>
<style scoped>
/* 工作流样式 */
.workflow-container {
  padding: 20px;
}

.workflow-steps {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin: 40px 0;
  padding: 0 20px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  min-width: 120px;
}

.step-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #e4e7ed;
  color: #606266;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  border: 3px solid #e4e7ed;
  transition: all 0.3s ease;
  margin-bottom: 10px;
}

.step-label {
  font-size: 14px;
  color: #303133;
  text-align: center;
  font-weight: 500;
  margin-bottom: 5px;
  padding: 0 5px;
}

.step-status {
  font-size: 12px;
  color: #909399;
  text-align: center;
}

/* 步骤状态样式 */
.step-completed .step-circle {
  background: #67c23a;
  color: white;
  border-color: #67c23a;
}

.step-current .step-circle {
  background: #409eff;
  color: white;
  border-color: #409eff;
  animation: pulse 2s infinite;
}

.step-pending .step-circle {
  background: #e4e7ed;
  color: #606266;
  border-color: #e4e7ed;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(64, 158, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0);
  }
}

/* 连线样式 */
.step-line {
  flex: 1;
  height: 4px;
  background: #e4e7ed;
  margin: 0 10px;
  position: relative;
  top: -22px;
  transition: all 0.3s ease;
}

.line-completed {
  background: #67c23a;
}

.line-active {
  background: linear-gradient(90deg, #67c23a 0%, #409eff 100%);
}

.line-pending {
  background: #e4e7ed;
}

/* 当前状态说明 */
.current-status {
  margin-top: 40px;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 8px;
  border-left: 4px solid #409eff;
}

.current-status h4 {
  margin: 0 0 10px 0;
  color: #303133;
  font-size: 16px;
}

.current-status p {
  margin: 0;
  color: #606266;
  line-height: 1.6;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .workflow-steps {
    flex-direction: column;
    gap: 30px;
  }

  .step-line {
    width: 4px;
    height: 40px;
    margin: 10px 0;
    top: 0;
  }
}
</style>

<style scoped>
.fixed-pagination {
  position: fixed;
  bottom: 20px;
  right: 50px; /* 距离右侧50px */
  background: white;
  padding: 10px 20px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
}
/* 工作流样式 */
.workflow-container {
  padding: 20px;
}

.workflow-steps {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin: 40px 0;
  padding: 0 20px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  min-width: 120px;
}

.step-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #e4e7ed;
  color: #606266;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  border: 3px solid #e4e7ed;
  transition: all 0.3s ease;
  margin-bottom: 10px;
}

.step-label {
  font-size: 14px;
  color: #303133;
  text-align: center;
  font-weight: 500;
  margin-bottom: 5px;
}

.step-status {
  font-size: 12px;
  color: #909399;
  text-align: center;
}

/* 步骤状态样式 */
.step-completed .step-circle {
  background: #67c23a;
  color: white;
  border-color: #67c23a;
}

.step-current .step-circle {
  background: #409eff;
  color: white;
  border-color: #409eff;
  animation: pulse 2s infinite;
}

.step-pending .step-circle {
  background: #e4e7ed;
  color: #606266;
  border-color: #e4e7ed;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(64, 158, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0);
  }
}

/* 连线样式 */
.step-line {
  flex: 1;
  height: 4px;
  background: #e4e7ed;
  margin: 0 10px;
  position: relative;
  top: -22px;
  transition: all 0.3s ease;
}

.line-completed {
  background: #67c23a;
}

.line-active {
  background: linear-gradient(90deg, #67c23a 0%, #409eff 100%);
}

.line-pending {
  background: #e4e7ed;
}

/* 当前状态说明 */
.current-status {
  margin-top: 40px;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 8px;
  border-left: 4px solid #409eff;
}

.current-status h4 {
  margin: 0 0 10px 0;
  color: #303133;
  font-size: 16px;
}

.current-status p {
  margin: 0;
  color: #606266;
  line-height: 1.6;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .workflow-steps {
    flex-direction: column;
    gap: 30px;
  }

  .step-line {
    width: 4px;
    height: 40px;
    margin: 10px 0;
    top: 0;
  }
}
.step-label {
  font-size: 14px;
  color: #303133;
  text-align: center;
  font-weight: 500;
  margin-bottom: 5px;
  padding: 0 5px; /* 增加内边距防止文字溢出 */
}
</style>
